<template>
  <div class="newPer" v-wechat-title="headtitle">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              ref="my_scroller"

    >
      <img :src="bannerImg" width="100%">
      <!--    <div class="share">-->
      <!--      <img src="../../../static/images/sharebanner.png">-->
      <!--      <div class="btn" @click="share">-->
      <!--        分享给好友-->
      <!--      </div>-->
      <!--    </div>-->
<!--      <div style="background-color: #fff;padding: 0.2rem 0.15rem;">-->
<!--        <ul>-->
<!--          <li v-for="(item, index) of list" :key="index" @click="newPerClick(item)">-->
<!--            <img v-lazy="item.img_path">-->
<!--            <div class="proMess">-->
<!--              <div class="tags">-->
<!--                <p v-if="item.tag1">{{item.tag1}}</p>-->
<!--                <p v-if="item.tag2">{{item.tag2}}</p>-->
<!--                <p v-if="item.tag3">{{item.tag3}}</p>-->
<!--                &lt;!&ndash;<p>产品卖点</p>&ndash;&gt;-->
<!--              </div>-->
<!--              <b>{{item.name}}</b>-->
<!--              <div class="span">-->
<!--                <div class="goods_price">-->
<!--                <span class="smallprice">-->
<!--                  <sub>¥</sub>-->
<!--                  <b>{{String(parseFloat(item.sales_price).toFixed(2)).slice(0, String(parseFloat(item.sales_price).toFixed(2)).indexOf('.'))}}</b>-->
<!--                  <sup>{{String(parseFloat(item.sales_price).toFixed(2)).slice(String(parseFloat(item.sales_price).toFixed(2)).indexOf('.'), String(parseFloat(item.sales_price).toFixed(2)).length)}}</sup>-->
<!--                </span>-->
<!--                </div>-->
<!--                <i>¥{{item.cost_price}}</i>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="clear"></div>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
      <div class="pro_list">
        <product-item v-for="(item, index) of list" :key="index" :prolistItem="item" :type="'notScrollTo'" :skuSwitch="'1'"></product-item>
      </div>
      <p class="footer" @click="productclassFn">海量商品等你来，点击查看<img src="../../../static/images/jt.png"></p>
    </Scroller>
    <van-overlay
      :show="showshare"
      z-index="99"
    >
    </van-overlay>
    <div class="sharecontainer" v-if="showshare == true">
      <img src="../../assets/images/sharemc.png"/>
      <van-button round plain  type="danger" class="know"  @click="showshare = false">我知道了</van-button>
    </div>
    <div class="homeBtn" @click="homeClick">
      <img src="/static/images/homebtn.png">
    </div>
  </div>
</template>

<script>
import { customRequestAjax } from '@/axiosApi'
import { kefu, fenxiang, isApp, basepath, isWeixin, wxAjaxData, browHistory } from '../../assets/common/js/config'
import wx from 'weixin-js-sdk'
import Scroller from '../common/Scroller'
import productItem from '../common/productItem'

export default {
  name: 'actintroduce',
  data () {
    return {
      list: [],
      headtitle: '',
      bannerImg: '',
      showshare: false,
      refresh: false,
      loading: false,
      finished: false,
      noDataText: '',
      nowPage: 0,
      title: '',
      desc: '',
      img: basepath + 'static/images/actruleshareimg.png',
      shareUrl: basepath + '/Wxmall/WeChat/share' + wxAjaxData
    }
  },
  components: {
    Scroller,
    productItem
  },
  mounted: function () {
    window.scrollTo(0, 0)
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    if (!sessionStorage.askPositon || from.path == '/') { // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next(vm => {
        Object.assign(vm.$data, vm.$options.data());
      })
    } else {
      next(vm => {
        if (from.path == '/') {
          Object.assign(vm.$data, vm.$options.data());
        }
        if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
          setTimeout(function () {
            window.scrollTo(0, sessionStorage.askPositon, false)
          }, 0) // 同步转异步操作
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    getData: function () {
      var url = 'Wxmall/Adactinfo/getGroupActivityItem?group_code=GIFTITEM&pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      if (this.$route.query.path == 'Friends') { // 小程序朋友圈广告标识
        url = 'Wxmall/Adactinfo/getGroupActivityItem?group_code=ADITEM&pageno=' + this.nowPage + '&pagesize=' + this.pagesize
        this.title = '补水神器，亮肤绝品，速来特惠尝鲜'
        this.desc = ''
        this.headtitle = this.$route.meta.title = '爆款特惠，速来尝鲜'
      }
      var that = this
      customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.headtitle = that.$route.meta.title = res.data.title ? res.data.title : that.headtitle
          if (that.nowPage === 1) {
            if (res.data.shareInfo && res.data.shareInfo.title) {
              that.title = res.data.shareInfo.title ? res.data.shareInfo.title : that.title
              that.desc = res.data.shareInfo.desc ? res.data.shareInfo.desc : that.desc
              that.img = res.data.shareInfo.img ? res.data.shareInfo.img : that.img
            }
            if (isWeixin()) {
              var arg = isApp()
              if (arg.indexOf('xcx') >= 0) {
                if (that.$route.query.path != 'Friends') {
                  var xcxObj = {
                    type: 'actdesc',
                    title: that.title,
                    img: that.img,
                    link: basepath + 'actintroduce?1=1' + arg
                  }
                  wx.miniProgram.postMessage({data: xcxObj})
                }
              } else if (arg == '') {
                if (that.$route.query.path != 'Friends') {
                  fenxiang({
                    title: that.title,
                    desc: that.desc,
                    imgx: that.img,
                    type: 'actdesc',
                    dataStr: 'type=actdesc',
                    path: 'actintroduce'
                  })
                } else {
                  fenxiang({path: 'actintroduce'})
                }
              }
            }
            that.bannerImg = res.data.bannerimg
            that.list = res.data.itemlist
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.itemlist)
            that.bannerImg = res.data.bannerimg
          }
          that.loading = false
          if (res.data.itemlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    productclassFn: function () {
      var arg = isApp()
      if (arg == '') {
        if (this.$route.query.type) {
          var that = this
          if (that.waptoken.waptoken && that.waptoken.waptoken == that.waptoken.tourists) {
            localStorage.setItem('htmlurl', window.location)
            window.location = '/login?routeval=html'
            return
          }
          browHistory({
            type: that.$route.query.type,
            page: window.location.href
          }, function () {
            that.$router.push({
              path: '/classification',
              query: {
                type: 'inside'
              }
            })
          })
        } else {
          this.$router.push({
            path: '/classification',
            query: {
              type: 'inside'
            }
          })
        }
      } else if (arg.indexOf('xcx') < 0) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'goCategroy'
        }))
      } else {
        wx.miniProgram.switchTab({url: '/pages/category/main'})
      }
    },
    share: function () {
      var arg = isApp()
      if (arg == '') {
        if (isWeixin()) {
          this.showshare = true
        } else {
          this.$toast('关注【创客村】公众号，惊喜享不停')
        }
      } else {
        var obj = {
          type: 'shareFriends',
          title: this.title,
          img: this.img,
          desc: this.desc,
          link: encodeURIComponent(this.shareUrl + '&type=actdesc')
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(obj))
      }
    },
    homeClick: function () {
      var arg = isApp()
      if (arg == '') {
        if (this.$route.query.type) {
          var that = this
          if (that.waptoken.waptoken && that.waptoken.waptoken == that.waptoken.tourists) {
            localStorage.setItem('htmlurl', window.location)
            window.location = '/login?routeval=html'
            return
          }
          browHistory({
            type: that.$route.query.type,
            page: window.location.href
          }, function () {
            that.$router.replace('/')
          })
        } else {
          this.$router.replace('/')
        }
      } else if (arg.indexOf('xcx') < 0) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'goIndex'
        }))
      } else {
        wx.miniProgram.switchTab({url: '/pages/index/main'})
      }
    },
    newPerClick: function (items) {
      var that = this
      var arg = isApp()
      if (arg == '') {
        if (this.$route.query.type) {
          if (that.waptoken.waptoken && that.waptoken.waptoken == that.waptoken.tourists) {
            localStorage.setItem('htmlurl', window.location)
            window.location = '/login?routeval=html'
            return
          }
          browHistory({
            type: that.$route.query.type,
            page: window.location.href
          }, function () {
            that.$router.push({
              path: '/productdetail',
              query: {
                itemid: items.itemid
              }
            })
          })
        } else {
          if (that.$route.query.path == 'Friends') {
            window.location.href = '/static/wx/html/38ylactpage/annProduct.html?path=Friends&itemid=' + items.itemid
          } else {
            that.$router.push({
              path: '/productdetail',
              query: {
                itemid: items.itemid
              }
            })
          }
        }
      } else if (arg.indexOf('xcx') < 0) {
        if (that.$route.query.path == 'Friends') {
          window.location.href = '/static/wx/html/38ylactpage/annProduct.html?path=Friends&itemid=' + items.itemid + arg
        } else {
          var obj = {
            type: 'goItemDetail',
            itembaseid: items.itemid
          }
          window.ReactNativeWebView.postMessage(JSON.stringify(obj))
        }
      } else {
        if (that.$route.query.path == 'Friends') {
          window.location.href = '/static/wx/html/38ylactpage/annProduct.html?path=Friends&itemid=' + items.itemid + arg
        } else {
          wx.miniProgram.navigateTo({url: '/pages/product/main?itemid=' + items.itemid})
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .newPer {
    background: #fff;
    /*min-height: 100%;*/
    >img {
      width: 100%;
    }
    .share {
      padding: 0.11rem 0.1rem 0;
      position: relative;
      img {
        width: 100%;
      }
      .btn {
        width: 1.07rem;
        height: 0.33rem;
        position: absolute;
        right: 0.24rem;
        top: 0.24rem;
        font-size: 0.14rem;
        color: #fff;
        text-align: center;
        line-height: 0.33rem;
        border-radius: 0.165rem;
        background:linear-gradient(0deg,rgba(254,109,101,1),rgba(254,168,168,1));
        background:-webkit-linear-gradient(0deg,rgba(254,109,101,1),rgba(254,168,168,1));
        background:-moz-linear-gradient(0deg,rgba(254,109,101,1),rgba(254,168,168,1));
        background:-ms-linear-gradient(0deg,rgba(254,109,101,1),rgba(254,168,168,1));
        background:-o-linear-gradient(0deg,rgba(254,109,101,1),rgba(254,168,168,1));
      }
    }

    .pro_list{
      padding: 0.1rem .11rem 0;
      background: #fff;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      .pro_item:nth-child(2n){
        padding-left: .035rem;
      }
      .pro_item:nth-child(2n-1){
        padding-right: .035rem;
      }
    }
    .footer {
      color: #888888;
      font-size: 0.13rem;
      background: #fff;
      text-align: center;
      padding: 0.08rem 0 0.14rem;
      line-height: 0.16rem;
      img {
        width: 0.065rem;
        height: 0.11rem;
        display: inline-block;
        margin-left: 0.04rem;
      }
    }

    .sharecontainer {
      position: fixed;
      width: 100%;
      z-index: 100;
      height: 100%;
      left: 0;
      top: 0;
      img {
        position: absolute;
        top: 0;
        right: .35rem;
        width: 1.53rem;
      }
      .know {
        width: 1.09rem;
        height: .36rem;
        line-height: .36rem;
        color: #fff;
        border-color: #fff;
        background: transparent;
        position: absolute;
        bottom: 1.5rem;
        left: 50%;
        margin-left: -.54rem;
      }
    }
    .homeBtn {
      z-index: 10;
      position: fixed;
      right: 0.1rem;
      bottom: .6rem;
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 50%;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
      -webkit-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
      -moz-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
      -ms-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
      -o-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
      display: flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      display: -o-flex;
      flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -webkit-flex-direction: column;
      -o-flex-direction: column;
      justify-content: center;
      -moz-justify-content: center;
      -ms-justify-content: center;
      -webkit-justify-content: center;
      -o-justify-content: center;
      align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -webkit-align-items: center;
      -o-align-items: center;

      img {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/38actpage/actintroduce.vue